

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Firebase imports
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import '../../firebase'; // ✅ make sure this is correct path to your firebase.jssss

const BrandLogin = () => {
  const navigate = useNavigate();
  const [userdata, setUserdata] = useState({ email: '', password: '' });
  const [passwordType, setPasswordType] = useState('password');

  const togglePassword = () => {
    setPasswordType(passwordType === 'password' ? 'text' : 'password');
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setUserdata({ ...userdata, [name]: value });
  };

  // 🔐 Email/Password Login
  const postdata = async (e) => {
    e.preventDefault();
    const { email, password } = userdata;
    try {
      const res = await fetch('https://server-side-influencer.onrender.com/brand/brandlogin', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();
      if (res.status === 200) {
        toast.success(data.message);
        localStorage.setItem('brandID', data.brandId);
        localStorage.setItem('Brandtoken', data.token);
        navigate('/BrandHome?page=1');
      } else {
        toast.error(data.error);
      }
    } catch (err) {
      toast.error('Something went wrong');
    }
  };

  // 🔐 Google Login
  const handleGoogleLogin = async () => {
    const auth = getAuth();
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const idToken = await result.user.getIdToken();

      const res = await fetch('https://server-side-influencer.onrender.com/brand/google-login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ idToken }),
      });

      const data = await res.json();
      if (res.status === 200) {
        toast.success('Google login successful');
        localStorage.setItem('brandID', data.brandId);
        localStorage.setItem('Brandtoken', data.token);
        navigate('/BrandHome?page=1');
      } else {
        toast.error(data.error || 'Google login failed');
      }
    } catch (err) {
      console.error('Google login error:', err);
      toast.error('Google sign-in failed');
    }
  };

  const navigateToSignUp = () => navigate('/BrandSignUp');
  const navigateToForgotPassword = () => navigate('/brandemail');

  return (
    <div className="font-[sans-serif]">
      <div className="min-h-screen flex flex-col items-center justify-center py-6 px-4" style={{ marginTop: '1%' }}>
        <div className="grid md:grid-cols-2 items-center gap-4 max-w-6xl w-full">
          <div className="border border-gray-300 rounded-lg p-6 max-w-md shadow-[0_2px_22px_-4px_rgba(93,96,127,0.2)] max-md:mx-auto">
            <form className="space-y-4" onSubmit={postdata}>
              <div className="mb-8">
                <h3 className="text-gray-800 text-3xl font-extrabold">Sign in as brand</h3>
                <p className="text-gray-500 text-sm mt-4 leading-relaxed">
                  Sign in as a brand to discover and collaborate with top influencers.
                </p>
              </div>

              <div>
                <label className="text-gray-800 text-sm mb-2 block">Email</label>
                <input
                  name="email"
                  type="email"
                  required
                  className="w-full text-sm text-gray-800 border border-gray-300 px-4 py-3 rounded-lg outline-blue-600"
                  placeholder="Enter email"
                  value={userdata.email}
                  onChange={handleInput}
                />
              </div>

              <div>
                <label className="text-gray-800 text-sm mb-2 block">Password</label>
                <div className="relative flex items-center">
                  <input
                    name="password"
                    type={passwordType}
                    required
                    className="w-full text-sm text-gray-800 border border-gray-300 px-4 py-3 rounded-lg outline-blue-600"
                    placeholder="Enter password"
                    value={userdata.password}
                    onChange={handleInput}
                  />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#bbb"
                    stroke="#bbb"
                    className="w-[18px] h-[18px] absolute right-4 cursor-pointer"
                    viewBox="0 0 24 24"
                    onClick={togglePassword}
                  >
                    <path d="M12 4C8.13 4 5 6.91 5 10s3.13 6 7 6 7-2.91 7-6-3.13-6-7-6zm0 10c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z" />
                  </svg>
                </div>
              </div>

              <div className="flex flex-wrap items-center justify-between gap-4">
                <div className="flex items-center">
                  <input id="remember-me" type="checkbox" className="h-4 w-4 text-blue-600 border-gray-300 rounded" />
                  <label htmlFor="remember-me" className="ml-3 block text-sm text-gray-800">
                    Remember me
                  </label>
                </div>
                <div className="text-sm">
                  <button
                    type="button"
                    onClick={navigateToForgotPassword}
                    className="text-blue-600 hover:underline font-semibold"
                  >
                    Forgot your password?
                  </button>
                </div>
              </div>

              {/* Email/Password Login */}
              <button
                type="submit"
                className="w-full shadow-xl py-3 px-4 text-sm tracking-wide rounded-lg text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:outline-none focus:ring-4 focus:ring-blue-300"
              >
                Log in
              </button>

              <div className="my-3 text-center text-gray-500 text-sm">or</div>

              {/* Google Login */}
           <button
  type="button"
  onClick={handleGoogleLogin}
  className="flex items-center justify-center gap-2 w-full mt-2 py-3 px-4 text-sm tracking-wide rounded-lg text-black bg-white border border-gray-300 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-red-300"
>
                <svg className="w-5 h-5" viewBox="0 0 533.5 544.3">
                  <path
                    fill="#4285F4"
                    d="M533.5 278.4c0-17.4-1.4-34.1-4.1-50.2H272v95.1h146.9c-6.4 34.6-25.4 63.9-54.2 83.5v68h87.7c51.3-47.2 81.1-116.8 81.1-196.4z"
                  />
                  <path
                    fill="#34A853"
                    d="M272 544.3c73.5 0 135.2-24.4 180.3-66.5l-87.7-68c-24.4 16.3-55.6 25.9-92.6 25.9-71.3 0-131.8-48.1-153.5-112.6h-90v70.5C80.9 483.3 169.7 544.3 272 544.3z"
                  />
                  <path
                    fill="#FBBC05"
                    d="M118.5 323.1c-10.3-30.2-10.3-62.7 0-92.9v-70.5h-90c-37.3 74.6-37.3 159.4 0 234z"
                  />
                  <path
                    fill="#EA4335"
                    d="M272 107.7c39.9-.6 78.3 13.9 107.5 40.9l80.2-80.2C405.3 24.4 343.6 0 272 0 169.7 0 80.9 61 28.5 159.7l90 70.5c21.6-64.6 82.2-112.6 153.5-112.6z"
                  />
                </svg>
                Log in with Google
              </button>

              <p className="text-sm mt-6 text-center text-gray-800">
                Don't have an account?
                <span
                  className="text-blue-600 font-semibold hover:underline ml-1 cursor-pointer"
                  onClick={navigateToSignUp}
                >
                  Register here
                </span>
              </p>
            </form>
          </div>

        <div className="flex items-center justify-center max-md:mt-8">
  <div className="flex items-center gap-3">
    <img
      src="https://i.postimg.cc/Rhd5hYcN/halfolog-removebg-preview.png"
      alt="Influenceso Logo"
      className="h-10 w-auto"
    />

    <h2 className="text-2xl font-semibold text-black flex items-baseline gap-2">
      <span className="font-bold">Influenceso</span>
      <span className="text-gray-600 text-lg">for Brands</span>
    </h2>
  </div>
  </div>
        </div>
      </div>
      <ToastContainer autoClose={800} />
    </div>
  );
};

export default BrandLogin;
